'use client';

import { c as _c } from "react/compiler-runtime";
import { RenderBoundary, SimulatedTradeStage as SharedStage, type SimulatedTradeStageProps, type StageAssets } from '@morfi/how-morfi-works';
import participant0 from '@morfi/how-morfi-works/assets/avatar-men-12.jpg';
import participant2 from '@morfi/how-morfi-works/assets/avatar-men-22.jpg';
import you from '@morfi/how-morfi-works/assets/avatar-men-32.jpg';
import participant1 from '@morfi/how-morfi-works/assets/avatar-men-46.jpg';
import participant4 from '@morfi/how-morfi-works/assets/avatar-men-54.jpg';
import dan from '@morfi/how-morfi-works/assets/avatar-men-75.jpg';
import participant5 from '@morfi/how-morfi-works/assets/avatar-women-26.jpg';
import priya from '@morfi/how-morfi-works/assets/avatar-women-44.jpg';
import maya from '@morfi/how-morfi-works/assets/avatar-women-65.jpg';
import participant3 from '@morfi/how-morfi-works/assets/avatar-women-68.jpg';
import cover from '@morfi/how-morfi-works/assets/market-cover.jpg';
import no from '@morfi/how-morfi-works/assets/outcome-no.jpg';
import yes from '@morfi/how-morfi-works/assets/outcome-yes.jpg';
import { usdToD6 } from '@morfi/how-morfi-works/engine';
import { useTranslations } from 'next-intl';
import { useFormattedCurrency } from '@/lib/currency';
import { sendLog } from '@/lib/telemetry';
import '@morfi/how-morfi-works/styles.css';
export type { StageControl } from '@morfi/how-morfi-works';
const assets: StageAssets = {
  avatars: {
    you: you.src,
    dan: dan.src,
    priya: priya.src,
    maya: maya.src
  },
  outcomes: {
    yes: yes.src,
    no: no.src
  },
  cover: cover.src,
  participants: [you.src, dan.src, priya.src, maya.src, participant0.src, participant1.src, participant2.src, participant3.src, participant4.src, participant5.src]
};

/** The web host owns translations, selected currency and navigation. */
export function SimulatedTradeStage(props) {
  const $ = _c(13);
  const t = useTranslations("simulated_trade");
  const {
    formatD6
  } = useFormattedCurrency();
  let t0;
  if ($[0] !== props.mode) {
    t0 = category => {
      sendLog("how_morfi_works.render_failed", "error", {
        category,
        mode: props.mode ?? "market"
      });
    };
    $[0] = props.mode;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== formatD6) {
    t1 = {
      money: usd => formatD6(usdToD6(usd), "whole"),
      compact: usd_0 => formatD6(usdToD6(usd_0), "compactTight").replace(/K/g, "k"),
      marketCap: usd_1 => formatD6(usdToD6(usd_1), usd_1 >= 1000000 ? "compactTight" : "compactWhole").replace(/K/g, "k").replace(/M/g, "m"),
      earnings: usd_2 => formatD6(usdToD6(usd_2), "compactTight").replace(/K/g, "k")
    };
    $[2] = formatD6;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t || $[5] !== t1) {
    t2 = {
      t,
      assets,
      format: t1
    };
    $[4] = t;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== props || $[8] !== t2) {
    t3 = <SharedStage {...props} presentation={t2} />;
    $[7] = props;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t0 || $[11] !== t3) {
    t4 = <RenderBoundary onFailure={t0}>{t3}</RenderBoundary>;
    $[10] = t0;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
}